import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Import useParams to get the slug from URL
import axios from "axios";
import { ChevronRight, ShoppingCart } from "react-feather";
import ProductReview from "../component/ProductReview";
import ProductCards from "../component/ProductCards";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import instock from "../component/img/instock.png";
import pay1 from "../component/img/pay1.png";
import { baseurl, imageUrl } from "../Baseurl";
import SharePage from "../component/SharePage";
import { Link } from "react-router-dom";
import Addtocartcomp from "../component/Addtocartcomp";
import CheckCart from "../component/CheckCart";
import SimilarProduct from "../component/SimilarProduct";
import DeliveryCharges from "./VisitorProduct/DeliveryCharges";
import ProductEnquiry from "./VisitorProduct/ProductEnquiry";
import ProductDirectSell from "./VisitorProduct/ProductDirectSell";
import ReactImageMagnify from "react-image-magnify";
import MagnifierImage from "../component/MagnifierImage";

import { HeadProvider } from "react-head";
import { Title, Meta } from "react-head";


const ProductDetail = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Error state
  // const [selectedImage, setSelectedImage] = useState("");
  const [categoryHierarchy, setCategoryHierarchy] = useState([]);
  const cust_id = localStorage.getItem("cust_id");

  const validMedia =
    product?.images?.filter((img) =>
      img.listing_image.match(/\.(jpg|jpeg|png|gif|webp|mp4)$/i)
    ) || [];

  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    const fetchProductDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}productBySlug/${slug}`);

        if (response.data.listing) {
          const productData = response.data.listing;

          // Find the default image
          const defaultImage =
            productData.images.find((img) => img.default === "yes")
              ?.listing_image || productData.images[0]?.listing_image;

          setProduct(productData);
          setSelectedImage(defaultImage); // Set default image
        }

        if (response.data.categoryHierarchy) {
          setCategoryHierarchy(response.data.categoryHierarchy);
        }

        setLoading(false);
      } catch (err) {
        setError("Error fetching product details");
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [slug]);



// const [selectedImage, setSelectedImage] = useState(product?.images?.[0]?.listing_image || "");

const [selectedIndex, setSelectedIndex] = useState(0);

const handlePrev = () => {
  setSelectedIndex((prev) =>
    prev === 0 ? product.images.length - 1 : prev - 1
  );
};

const handleNext = () => {
  setSelectedIndex((prev) =>
    prev === product.images.length - 1 ? 0 : prev + 1
  );
};

useEffect(() => {
  if (product?.images?.length) {
    setSelectedImage(product.images[selectedIndex].listing_image);
  }
}, [selectedIndex, product]);










  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>; // Display error message if any
  }

  const isValidImage = (file) => /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
  const isValidVideo = (file) => /\.mp4$/i.test(file);
  // Find the first valid image from the array if selectedImage is not an image
  const validImage = product.images.find(isValidImage) || null;

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;


  console.log("dollarRate", dollarRate);

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };

  return (
    <>


{product && (
  <>
    {/* TITLE */}
    <Title>{product.title} </Title>

    {/* META DESCRIPTION */}
    <Meta
      name="description"
      content={
        product.description
          ?.replace(/<[^>]+>/g, "")
          ?.slice(0, 160) || product.title
      }
    />

    {/* CANONICAL */}
    <Link
      rel="canonical"
      href={`https://techsparesindia.com/product/${product.slug}`}
    />

    {/* ROBOTS */}
    <Meta name="robots" content="index, follow" />

    {/* OG TAGS */}
    <Meta property="og:title" content={product.title} />
    <Meta
      property="og:description"
      content={
        product.description
          ?.replace(/<[^>]+>/g, "")
          ?.slice(0, 200) || product.title
      }
    />
    <Meta
      property="og:image"
      content={`${imageUrl}${product.images?.[0]?.listing_image}11`}
    />
    <Meta
      property="og:url"
      content={`https://techsparesindia.com/product/${product.slug}`}
    />
    <Meta property="og:type" content="product 11" />

    {/* TWITTER TAGS */}
    <Meta name="twitter:card" content="summary_large_image" />
    <Meta name="twitter:title" content={product.title} />
    <Meta
      name="twitter:description"
      content={
        product.description
          ?.replace(/<[^>]+>/g, "")
          ?.slice(0, 200) || product.title
      }
    />
    <Meta
      name="twitter:image"
      content={`${imageUrl}${product.images?.[0]?.listing_image}`}
    />

  
  </>
)}




      <VisitorNavbar />
      <div className="container-fluid mt-3">
        <div className="text-start brdcrm1 mb-3">
          <span>Home</span>
          <span>
            <ChevronRight size={12} />
          </span>

          {categoryHierarchy.length >= 5 && (
            <>
              <span>{categoryHierarchy[0].title}</span>
              <span>
                <ChevronRight size={12} />
              </span>
              <span>{categoryHierarchy[1].title}</span>
              <span>
                <ChevronRight size={12} />
              </span>
              <span>{categoryHierarchy[2].title}</span>
              <span>
                <ChevronRight size={12} />
              </span>
              <span>{categoryHierarchy[3].title}</span>
              <span>
                <ChevronRight size={12} />
              </span>
              <span>{categoryHierarchy[4].title}</span>
            </>
          )}
        </div>
        <div className="row">
          {/* Product Image Section */}
          <div className="col-md-6">
            <div className="box_detail">
              {/* Main Image */}
              {/* <div className="main-image">
                {isValidVideo(selectedImage) ? (
                  <video controls className="img-fluid border rounded">
                    <source
                      src={`${imageUrl}listing/${selectedImage}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                ) : isValidImage(selectedImage) ? (
                  <MagnifierImage
                    src={`${imageUrl}listing/${selectedImage}`}
                    zoom={2}
                  />
                ) : (
                  <p>No valid image available</p>
                )}
              </div> */}


              <div className="main-image position-relative">
  {isValidVideo(selectedImage) ? (
    <video controls className="img-fluid border rounded">
      <source
        src={`${imageUrl}listing/${selectedImage}`}
        type="video/mp4"
      />
      Your browser does not support the video tag.
    </video>
  ) : isValidImage(selectedImage) ? (
    <MagnifierImage
      src={`${imageUrl}listing/${selectedImage}`}
      zoom={2}
    />
  ) : (
    <p>No valid image available</p>
  )}

  {/* Left Arrow */}
  <button
    onClick={handlePrev}
    className="btn btn-light position-absolute top-50 start-0 translate-middle-y"
    style={{ zIndex: 10 }}
  >
    ‹
  </button>

  {/* Right Arrow */}
  <button
    onClick={handleNext}
    className="btn btn-light position-absolute top-50 end-0 translate-middle-y"
    style={{ zIndex: 10 }}
  >
    ›
  </button>
</div>



              {/* Thumbnails */}
              <div
                className="thumbnails d-flex mt-3"
                style={{ flexWrap: "wrap" }}
              >
                {product.images.map((thumb, index) => (
                  <div
                    key={index}
                    style={{ width: "70px", cursor: "pointer" }}
                    className={`me-1 ${
                      thumb.listing_image === selectedImage
                        ? "border border-primary"
                        : ""
                    }`}
                    onClick={() => setSelectedImage(thumb.listing_image)}
                  >
                    {isValidVideo(thumb.listing_image) ? (
                      <video
                        src={`${imageUrl}listing/${thumb.listing_image}`}
                        className="img-thumbnail"
                        style={{ width: "100%" }}
                      />
                    ) : (
                      <img
                        src={`${imageUrl}listing/${thumb.listing_image}`}
                        alt={`Thumbnail ${index + 1}`}
                        className="img-thumbnail"
                        style={{ width: "100%" }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Product Details Section */}
          <div className="col-md-6 text-start">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {categoryHierarchy.length >= 1 && (
                  <>
                    <h5 className="brand-name mb-3">
                      {" "}
                      {categoryHierarchy[2].title}
                    </h5>
                  </>
                )}

                {/* <h5 className="brand-name">{product.title}</h5> */}
              </div>
              <div>{/* <SharePage /> */}</div>
            </div>
            {/* <h5 className="brand-name">{product.brand_name}</h5> */}
            <h2 className="product-name txtnrml">{product.title}</h2>

            <div className="d-flex flex-column">
  {product.type === "directSell" ? (
    <div className="text-warning">

      {/* MRP */}
      {product.mrp && product.mrp !== 0 && (
        <div className="text-dark" style={{ textDecoration: "line-through" }}>
          M.R.P : {convertPrice(product.mrp, product.currency)}
        </div>
      )}

      {/* Price */}
      <span className="priceproduct">
        {convertPrice(product.price, product.currency)}
      </span>{" "}

      {/* GST only when INR */}
      {selectedCurrency?.toUpperCase() === "INR" && (
        <>
          <span className="text-dark" style={{ fontSize: ".89rem" }}>
            <strong><i>+ {product.gst}% GST Extra</i></strong>
          </span>

          <span className="text-muted d-block">
            Including GST:{" "}
            {convertPrice(
              (product.price * (1 + product.gst / 100)).toFixed(2),
              product.currency
            )}
          </span>
        </>
      )}

      {/* Amount in words only for INR */}
      {selectedCurrency?.toUpperCase() === "INR" && (
        <div className="amount-in-words">
          (
          {(() => {
            const ones = [
              "", "One","Two","Three","Four","Five","Six","Seven","Eight","Nine",
              "Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen",
              "Seventeen","Eighteen","Nineteen",
            ];
            const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

            const convertToWords = (n) => {
              if (n < 20) return ones[n];
              if (n < 100)
                return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
              if (n < 1000)
                return ones[Math.floor(n / 100)] + " Hundred" +
                  (n % 100 ? " and " + convertToWords(n % 100) : "");
              if (n < 100000)
                return convertToWords(Math.floor(n / 1000)) + " Thousand" +
                  (n % 1000 ? " " + convertToWords(n % 1000) : "");
              if (n < 10000000)
                return convertToWords(Math.floor(n / 100000)) + " Lakh" +
                  (n % 100000 ? " " + convertToWords(n % 100000) : "");
              return convertToWords(Math.floor(n / 10000000)) + " Crore" +
                (n % 10000000 ? " " + convertToWords(n % 10000000) : "");
            };

            if (!product.price) return "";

            return convertToWords(Math.floor(product.price)) + " Rupees";
          })()}
          )
        </div>
      )}

    </div>
  ) : product.type === "quoteRequest" ? (
    <span className="current-price"></span>
  ) : null}
</div>



            {/* <div className="">
              <span className="mrp1">M.R.P.:&nbsp;</span>
              <span className="mrp2">&#8377;{product.mrp}</span>
            </div> */}

            <div className="mb-3">
  {/* Show "In Stock" if unlimited is true OR quantity is greater than 0 */}
  {product.unlimitedquantity || product.quantity > 0 ? (
    <span className="instock">
      <i className="bi bi-check-circle me-1"></i>
      In Stock
    </span>
  ) : (
    <span className="text-danger">
      <i className="bi bi-x-circle me-1"></i>
      <strong>Out of Stock</strong>
    </span>
  )}
</div>

{/* Allow Add to Cart if unlimited is true OR quantity is greater than 0 */}
{(product.unlimitedquantity || product.quantity > 0) && (
  <div className="mb-3">
    <Addtocartcomp
      type={product.type}
      listing_id={product.listing_id}
    />
  </div>
)}






<div className="d-flex mb-3">

  {/* If Quote Request → Show ONLY Enquire Now */}
  {product.type === "quoteRequest" ? (
    localStorage.getItem("cust_id") ? (
      <ProductEnquiry
        listing_id={product.listing_id}
        seller_id={product.seller_id}
      />
    ) : (
      <a href="/customer/login" className="adcas">
        Enquire Now
      </a>
    )
  ) : (
    /* Else show ONLY Direct Purchase */
    <>
      {cust_id ? (
        <ProductDirectSell
          listing_id={product.listing_id}
          seller_id={product.seller_id}
        />
      ) : (
        <a href="/customer/login" className="">
          <span type="button" className="adcas">
            Direct Purchase
          </span>
        </a>
      )}
    </>
  )}

</div>






            <SharePage />

            {/* <div>
              <table className="table text-capitalize">
                <tr>
                  <th>Condition : </th>
                  <td>{product.condition}</td>
                </tr>
              </table>
            </div> */}

            {/* Product Details Table */}
            <table className="table1 text-capitalize">
              <tbody>
                {categoryHierarchy.length >= 5 && (
                  <>
                    <tr>
                      <td className="td1">Brand/Make</td>
                      <td className="td2">{categoryHierarchy[3].title}</td>
                    </tr>
                    <tr>
                      <td className="td1">Model Number</td>
                      <td className="td2">{categoryHierarchy[4].title}</td>
                    </tr>
                  </>
                )}

                <tr>
                  <td className="td1">Condition</td>
                  <td className="td2">{product.condition}</td>
                </tr>

                {/* <tr>
          <td className="td1">Standard</td>
          <td className="td2">{product.listingStandard}</td>
        </tr> */}

                <tr>
                  <td className="td1">Unit Quantity</td>
                  <td className="td2">
                    {product.listingStandard} {product.unitquantity || 1}
                  </td>
                </tr>

                <tr>
                  <td className="td1">Stock Available</td>
                  <td className="td2">
                    {product.unlimitedquantity ? "Unlimited" : product.quantity}
                  </td>
                </tr>

                {product.mpn && (
                  <tr>
                    <td className="td1">Manufacturer Part No.</td>
                    <td className="td2">{product.mpn}</td>
                  </tr>
                )}



                {product.delivery_time && (
                  <tr>
                    <td className="td1">Shipped In</td>
                    <td className="td2">{product.delivery_time}</td>
                  </tr>
                )}

                {product.installation_type && (
                  <tr>
                    <td className="td1">Installation Type</td>
                    <td className="td2">{product.installation_type}</td>
                  </tr>
                )}

                {product.installation_charge && (
                  <tr>
                    <td className="td1">Installation Charge</td>
                    <td className="td2">{product.installation_charge}</td>
                  </tr>
                )}

                {product.availableat && (
                  <tr>
                    <td className="td1">Product Available At</td>
                    <td className="td2">{product.availableat}</td>
                  </tr>
                )}

                {product.qkid && (
                  <tr>
                    <td className="td1">Product Key</td>
                    <td className="td2">{product.qkid}</td>
                  </tr>
                )}

                {/* <tr>
          <td className="td1">Seller</td>
          <td className="td2">{product.delivery_method}</td>
        </tr> */}
              </tbody>
            </table>

            {product.delivery_method && (
              <DeliveryCharges
                delivery_method={product.delivery_method}
                standard_delivery_charge={product.standard_delivery_charge}
                distance_based_charges={product.distance_based_charges}
                origin_pincode={product.origin_pincode}
                delivery_notes={product.delivery_notes}
              />
            )}

            <div>
              {product.documents && product.documents.length > 0 && (
                <div>
                  <h1 className="txt1 text-start">Brochure</h1>
                  <div className="document-grid">
                    {product.documents.map((doc, index) => (
                      <div key={index} className="document-card">
                        <div className="document-info">
                          <span>
                            <a
                              href={`${imageUrl}documents/${doc.document_name}`}
                              download={doc.document_name}
                              target="_blank"
                              className="download-btn"
                            >
                              📄 File {index + 1}
                            </a>
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <table className="table1">
              <tbody>
                {product.categoryHierarchy &&
                  product.categoryHierarchy.map((category, index) => (
                    <tr key={index}>
                      <td className="td1">Menu {index + 1}</td>
                      <td className="td2">{category.title}</td>
                    </tr>
                  ))}
              </tbody>
            </table>

            {/* Product Description Section */}
            <hr />

            {/* Other Details */}
            {/* <div>
              <h1 className="txt1 text-start">Other Details</h1>
              <table className="table1 table-striped">
                {product.other_details &&
                  product.other_details.map((detail, index) => (
                    <tr key={index}>
                      <td className="td1">{detail.label}</td>
                      <td className="td2">{detail.value}</td>
                    </tr>
                  ))}
              </table>
            </div> */}

            {/* Key Values */}
            {/* <hr /> */}
            {product.key_values && product.key_values.length > 0 && (
              <div>
                <h1 className="txt1 text-start">Key Features</h1>
                <table className="table1">
                  <tbody>
                    {product.key_values.map((keyValue, index) => (
                      <tr key={index}>
                        <td className="td1">{keyValue.key}</td>
                        <td className="td2">{keyValue.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <div className="product-info">
              {product.warranty && (
                <div className="info-section">
                  <h4>Warranty</h4>
                  <p>{product.warranty}</p>
                </div>
              )}
              {product.return_policy && (
                <div className="info-section">
                  <h4>Return Policy</h4>
                  <p>{product.return_policy}</p>
                </div>
              )}
            </div>
          </div>

          {/* <hr />

          <div className="text-center pay1cls">
            <img src={pay1} className="img-fluid" />
            <div className="payttl">Guaranteed Safe And Secure Checkout</div>
          </div> */}
        </div>

        <div className="row mt-5 text-start">
          <h1 className="txt1 text-start">Description</h1>
          {product.description ? (
            <div dangerouslySetInnerHTML={{ __html: product.description }} />
          ) : (
            <p>No description available.</p>
          )}
        </div>

        {/* Product Review Section */}
        <div className="row mt-5">
          <ProductReview productid={product.listing_id} />
        </div>

        {categoryHierarchy.length >= 1 && (
          <>
            <section className="py-5 px-2">
              <h1 className="txt1">Similar Products</h1>

              <div>
                <SimilarProduct producttitle={categoryHierarchy[2].title} />
              </div>
            </section>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ProductDetail;
